import { render, staticRenderFns } from "./AudioPlay.vue?vue&type=template&id=1c1f4387&"
import script from "./AudioPlay.vue?vue&type=script&lang=js&"
export * from "./AudioPlay.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports